import {Header} from "semantic-ui-react";
import React from "react";

const genres = [
    {key: 0, text: 'Action', value: 'Action', content:(<Header className='itemFont' subheader='Action'/>)},
    {key: 1, text: 'Adventure', value: 'Adventure', content:(<Header className='itemFont' subheader='Adventure'/>)},
    {key: 2, text: 'Biography', value: 'Biography', content:(<Header className='itemFont' subheader='Biography'/>)},
    {key: 3, text: 'Comedy', value: 'Comedy', content:(<Header className='itemFont' subheader='Comedy'/>)},
    {key: 4, text: 'Crime', value: 'Crime', content:(<Header className='itemFont' subheader='Crime'/>)},
    {key: 5, text: 'Drama', value: 'Crime', content:(<Header className='itemFont' subheader='Drama'/>)},
    {key: 6, text: 'Family', value: 'Family', content:(<Header className='itemFont' subheader='Family'/>)},
    {key: 7, text: 'Fantasy', value: 'Fantasy', content:(<Header className='itemFont' subheader='Fantasy'/>)},
    {key: 8, text: 'Historical', value: 'Historical', content:(<Header className='itemFont' subheader='Historical'/>)},
    {key: 9, text: 'Horror', value: 'Horror', content:(<Header className='itemFont' subheader='Horror'/>)},
    {key: 10, text: 'Mystery', value: 'Mystery', content:(<Header className='itemFont' subheader='Mystery'/>)},
    {key: 11, text: 'Romance', value: 'Romance', content:(<Header className='itemFont' subheader='Romance'/>)},
    {key: 12, text: 'Sci-Fi', value: 'Sci-Fi', content:(<Header className='itemFont' subheader='Sci-Fi'/>)},
    {key: 13, text: 'Sport', value: 'Sport', content:(<Header className='itemFont' subheader='Sport'/>)},
    {key: 14, text: 'Thriller', value: 'Thriller', content:(<Header className='itemFont' subheader='Thriller'/>)},
    {key: 15, text: 'War', value: 'War', content:(<Header className='itemFont' subheader='War'/>)},
    {key: 16, text: 'Western', value: 'Western', content:(<Header className='itemFont' subheader='Western'/>)}
]

export default genres
